import React, {Component} from "react";
import Categories from "./Categories";
import AdminMessages from "./AdminMessages";
import AdminPayments from "./AdminPayments";
class AdminMenu extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selected:'categories',
            active:'',
            status:'stripe t',
        }
        
    }
   
    selected = (status) => {
        this.setState({selected:status})
    }

    render() {
        return( 
            <>
            <div className='row'>
                <div className='col col-lg-2 mt-5 pt-5'>
                    <div className="card mt-5 ms-5" style={{width: '15rem'}}>
                    <div className="card-header bg-primary" style={{textAlign:'center'}}>
                        <h2>Menu</h2>
                    </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item"><button className='btn' onClick={() => this.selected('categories')} style={{width:'200px',textAlign:'left'}}>Categories</button></li>
                            <li className="list-group-item"><button className='btn' onClick={() => this.selected('msg')} style={{width:'200px',textAlign:'left'}}>User Messages</button></li>
                            <li className="list-group-item"><button className='btn' onClick={() => this.selected('payments')} style={{width:'200px',textAlign:'left'}}>New Payments</button></li>
                            <li className="list-group-item"><button className='btn' onClick={() => this.selected('payments t')} style={{width:'200px',textAlign:'left'}}>Transfered Payments</button></li>
                            
                        </ul>
                    </div>
                </div>
                <div className='col me-5'>
                {this.state.selected === 'categories' ?
                    <Categories/>
                    :
                this.state.selected === 'msg' ?    
                    <AdminMessages/>
                    :
                this.state.selected === 'payments' ?
                    <AdminPayments state='stripe'/>
                    :
                this.state.selected === 'payments t' ?
                    <AdminPayments state='stripe t'/>
                    :
                    null
                }
                </div>
            </div>
            </>
        )
    }
}
export default AdminMenu;